import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LogService } from 'app/_services/logmanager.service';
import { AuthenticationService } from 'app/_services/authentication.service';
import { GlobalsService } from 'app/_services/globals.service';

@Component({
    templateUrl: 'login.component.html'
})

export class LoginComponent implements OnInit {
    model: any = {};
    expired = false;
    loading = true;
    desconnectar = '';
    @Output() loginFinished = new EventEmitter<boolean>();
    returnUrl: string;
    navigationExtras: any = {};
    private token: string;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private globalStorage: GlobalsService
    ) { }

    ngOnInit() {
        // reset login status
        LogService.log('LoginComponent', '****** login init...');

        // get return url from route parameters or default to '/'
        this.returnUrl = this.globalStorage.getItem('returnUrl');
        if (this.returnUrl === '') {
            this.returnUrl = '/';
        }
        if (this.globalStorage.getItem('navigationExtras') === '') {
            this.navigationExtras = [];
        } else {
            this.navigationExtras = JSON.parse(this.globalStorage.getItem('navigationExtras'));
        }

        this.token = this.route.snapshot.queryParams['token'] || '';

        if (this.route.snapshot.queryParams['secretaria']) {
            this.returnUrl = '/';
        } else {
            this.token = this.globalStorage.getItem('token');
        }

        this.globalStorage.removeItem('returnUrl').then(
            () => {
                this.globalStorage.removeItem('navigationExtras').then(
                    () => {
                        this.login();
                    }
                );
            }
        );
    }

    login() {
        LogService.log('LoginComponent', '****** login call...');
        // comprobado ya en el globalstorage
        this.loading = false;
        this.loginFinished.emit(true);
        LogService.log('LoginComponent', '****** login finished');

        const user = this.globalStorage.getItem('currentUser');
        const userinfo = JSON.parse(user);
        LogService.log('LoginComponent', '****** login user:');
        LogService.log('LoginComponent', user);
        LogService.log('LoginComponent', '****** login userinfo:');
        LogService.log('LoginComponent', userinfo);

        if (!userinfo || !userinfo.username) {
            this.globalStorage.clear().then( () => {
                this.expired = true;
                this.desconnectar = userinfo.campusdir;
            });
        }

        if (this.returnUrl !== '/') {
            LogService.log('LoginComponent', '****** login returnUrl:'
                + this.returnUrl + ' / params: '
                + JSON.stringify(this.navigationExtras));
            LogService.log('LoginComponent', '****** login return QueryParams: ' + JSON.stringify(this.navigationExtras));
            this.router.navigate([this.returnUrl], { queryParams: this.navigationExtras});
        } else {
            LogService.log('LoginComponent', '****** login returnUrl:' + this.returnUrl);
            this.router.navigate([this.returnUrl]);
        }
    }

    /*doLogin()
    {
        this.authenticationService.login(this.token)
        .subscribe(
            () => {
                this.login();
            },
            () => {
                LogService.log('LoginComponent', '****** login error');
                this.loading = false;
                this.loginFinished.emit(false);
            });
    }*/
}
